import axios from "axios"

class PostsPlanService {
  api
  constructor() {
    this.api = axios.create({
      baseURL: `${process.env.REACT_APP_API_URL}`,
    })
    this.api.interceptors.request.use((config) => {
      const token = localStorage.getItem("Token")

      if (token) {
        config.headers = {
          Authorization: `Token ${token}`,
          withCredentials: false,
          "Content-Type": "application/json; charset=UTF-8",
        }
      }

      return config
    })
  }
  getPosts_planList = async () => {
    try {
      const response = await this.api.get(`/posts-plan/`)
      return response.data
    } catch (error) {
      throw error
    }
  }

  getPosts_planDetails = async (posts_planId) => {
    try {
      const response = await this.api.get(`/posts-plan/${posts_planId}/`)
      return response.data
    } catch (error) {
      throw error
    }
  }

  createPosts_plan = async (posts_planData) => {
    try {
      const response = await this.api.post(`/posts-plan/`, posts_planData)
      return response.data
    } catch (error) {
      throw error
    }
  }

  updatePosts_plan = async (posts_planId, posts_planData) => {
    try {
      const response = await this.api.put(
        `/posts-plan/${posts_planId}/`,
        posts_planData
      )
      return response.data
    } catch (error) {
      throw error
    }
  }

  deletePosts_plan = async (posts_planId) => {
    try {
      const response = await this.api.delete(`/posts-plan/${posts_planId}/`)
      return response.data
    } catch (error) {
      throw error
    }
  }
}

const postsPlanService = new PostsPlanService()

export default postsPlanService
